import {
  IAddInterviewerAPIPayload,
  IDeleteInterviewerAPIPayload,
} from '../../types/Interviews/interviewers.types';
import { HTTP_METHODS } from '../../constants/HttpConstants';
import {
  sendRequestToDoloresService,
  sendRequestToDoSelectCentralService,
} from '../../utils/request';

export const getInterviewersApi = () =>
  sendRequestToDoloresService({
    method: HTTP_METHODS.GET,
    url: 'interviewers?is_active=true&_limit=150&_offset=0',
  });

export const addInterviewerApi = (payload: IAddInterviewerAPIPayload) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.POST,
    url: '/rpc/invite.interviewer_invite',
    data: payload,
  });

export const deleteInterviewerApi = ({ email }: IDeleteInterviewerAPIPayload) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.DELETE,
    url: '/rpc/invite.interviewer_invite',
    data: {
      email: email,
    },
  });
